module.exports = __webpack_public_path__ + "img/icons8-smartphone-94.cac23359.png";